import { createReducer } from 'Helpers/redux'
import {
  GET_PAYOUTS,
  GET_AWAITING_PAYOUTS,
  GET_PAID_PAYOUTS,
  PAYOUT_TO_CURATOR,
  SEND_RECIPIENT_CHECKING_NEEDED,
  CANCEL_PAYOUT,
} from '../actions/payoutsActions'

const initialState = {
  sent: 1,
  payouts: [],
  totalBalance: 0,
  awaitingPayouts: [],
  paidPayouts: [],
  payoutsCount: {
    awaitingPayouts: 0,
    paidPayouts: 0,
    total_payouts: 0,
    total_paid: 0,
    total_awaiting: 0,
  },
}

const handlers = {
  [GET_PAYOUTS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    payouts: payload.payouts,
    totalBalance: payload.total_balance,
  }),
  [GET_AWAITING_PAYOUTS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    awaitingPayouts: payload.payouts,
    totalBalance: payload.total_balance,
    payoutsCount: { ...prevState.payoutsCount, awaitingPayouts: payload.total },
  }),
  [GET_PAID_PAYOUTS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    paidPayouts: payload.payouts,
    totalBalance: payload.total_balance,
    payoutsCount: {
      ...prevState.payoutsCount,
      paidPayouts: payload.total,
      total_payouts: payload.total_payouts,
      total_paid: payload.total_paid,
      total_awaiting: payload.total_awaiting,
    },
  }),
  [PAYOUT_TO_CURATOR.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    payouts: prevState.payouts.map(item =>
      item.id === payload.id ? { ...item, status: 'paid' } : item
    ),
  }),
  [SEND_RECIPIENT_CHECKING_NEEDED.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    sent: payload,
  }),
  [CANCEL_PAYOUT.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    payouts: prevState.payouts.map(payout =>
      payout.id === payload.id ? { ...payout, status: 'cancelled' } : payout
    ),
  }),
}

export default createReducer(initialState, handlers)
